<template>
  <router-view />
</template>

<script setup>
console.log("setup success");
</script>

<style></style>
